import React, { Component, Fragment } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import TrainingRequirementFormatter from '../training_requirement_formatter'
import MatrixTraineeDetails from '../trainee_details/matrix_trainee_details';
import CopyIcon from '../copy_icon';

class MatrixTable extends Component {
  constructor(props){
    super(props);

    this.columns = []
    this.state = {
      trainingMatrix:[],
    }

    this.currentRowIndex = null

    this.tableRef = React.createRef();
    this.lastScrollTop = 0
  }

  componentDidMount(){
    this.tableRef.current.addEventListener("scroll", function (event) {
      if ((this.getDocHeight() < this.getScrollXY()[1] + this.tableRef.current.offsetHeight) &&  this.getScrollXY()[1] > this.lastScrollTop){ 
        if (!this.props.loadingComplianceRatings){
          this.lastScrollTop = this.getScrollXY()[1]
        } else {
          this.lastScrollTop = 0
        }
      }
    }.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    var { trainingMatrix, trainingModules } = nextProps
    this.createColumns(trainingModules)
    this.setState({
      trainingMatrix: trainingMatrix,
    })
  }

  shouldComponentUpdate(nextProps, nextState){
    if (nextProps.restrictUpdate){
      return false;
    }
    else {
      return true;
    }
  }

  getScrollXY = () => {
    var scrOfX = 0, scrOfY = 0;
    if( this.tableRef.current && ( this.tableRef.current.scrollLeft || this.tableRef.current.scrollTop ) ) {
      //DOM compliant
      scrOfY = this.tableRef.current.scrollTop;
      scrOfX = this.tableRef.current.scrollLeft;
    }
    return [ scrOfX, scrOfY ];
  }
    
  getDocHeight = () => {
    var D = this.tableRef.current;
    return Math.max( D.scrollHeight, D.offsetHeight, D.clientHeight );
  }

  createColumns = (trainingModules) => {
    this.columns = []
    this.columns.push({
      dataField: 'fullname',
      text: '',
      formatter: this.nameCellFormatter,
      headerStyle: { width: '200px' },
      headerTitle: true,
      title: true,
      attrs: { isname: "true" },
      style: { cursor: "pointer", textAlign: "left", pointerEvents: 'auto' },
    })

    var categories = [ 'all', 'field', 'other', 'emergency' ]
    for (var j in categories) {
      var category = categories[j]
      if (!trainingModules[category] || trainingModules[category].length===0) continue

      for (var k in trainingModules[category]) {
        const module = trainingModules[category][k]
        this.columns.push({
          dataField: category + '_' +  module.id,
          text: module.name,
          formatter: (cell, row, rowIndex) => this.dateCellFormatter(cell, row, rowIndex, module),
          headerStyle: { width: '120px', textAlign: 'center' },
          classes: this.dateCellClass,
          editable: false,
          attrs: this.cellAtttributes,
          style: this.cellStyles
        })
      }

      this.columns.push({
        dataField: 'compliance_' + category,
        text: 'Compliance Rating (' + category[0].toUpperCase() + category.slice(1) + ')',
        classes: 'table-module-header',
        headerStyle: { width: '120px', textAlign: 'center' },
        title: true,
        editable: false,
        style: this.cellStyles
      })
    }

    //No training records added
    if(this.columns.length === 1) return

    this.columns.push({
      dataField: 'compliance_overall',
      text: 'Compliance Rating (Overall)',
      classes: 'table-module-header',
      headerStyle: { width: '120px', textAlign: 'center' },
      title: true,
      editable: false,
    })
  }

  cellAtttributes = (cell, row, rowIndex, colIndex) => {
    if (row.id === "modules_group") {
      if(cell !== null && cell !== undefined) {
        return { colSpan: cell.size }
      } 
      else {
        return ""
      }
    } 
    else {
      return { colindex: colIndex, id: (cell ? cell.name : colIndex) }
    }
  }

  cellStyles = (cell, row, rowIndex, colIndex) => {
    if (row.id === "modules_group") {
      if(cell !== null && cell !== undefined) {
        return { display: 'table-cell'}
      } 
      else {
        return { display: 'none' }
      }
    }
    else if (row.id === "module_name") {
      return {display: 'table-cell', padding: '2px'}
    }
    else {
      return { display: 'table-cell', padding: '0px'}
    }
  }

  dateCellClass = (cell, row, rowIndex, colIndex) => {
    if(row.id === "refresher_period") {
      return 'table-refresher-header'
    }
    else if(row.id === "modules_group") {
      return 'table-module-category'
    }
    else if(row.id === "module_name" || row.id === "compliance_ratings") {
      return 'table-module-header'
    }
    if(typeof cell !== 'object') {
      return 'legends-training-not-needed'
    }
    return 'legends-training-' + cell.status
  }

  dateCellFormatter = (cell, row, rowIndex, training_module ) => {
    if(row.id === "refresher_period") {
      var text = cell
      if (cell !== null){
        text = cell.toString() === '0' ? 'As required' : cell + ' years'
      } else {
        text = 'As required'
      }
      return text
    }
    else if(row.id === "modules_group") {
      if(typeof cell !== 'object') {
        return ""
      }
      return cell.text
    }
    else if(row.id === "module_name") {
      const category_desc = cell.category === 'all' ? 'All Staff' : 'Team Specific';
      return (
        <Fragment>
          {
            cell.link
            ?
            <div>
              <a onClick={(evt)=>evt.stopPropagation()} href={cell.link} target='_blank'>{cell.name}</a>
              <CopyIcon value={cell.link}/>
            </div>
            :
            <div>
              { cell.name }
            </div>
          }
          <div className="category">({category_desc})</div>
        </Fragment>
      )
    }
    else if(row.id === "compliance_ratings") {
      return cell
    }
    else if(typeof cell !== 'object') {
      const { id, default_frequency } = training_module || {};
      cell = {
        id: null,
        frequency: default_frequency,
        status: 'not-needed',
        trainee_id: row.id,
        module_id: id,
        date_completed: null
      }
    }

    return (
      <TrainingRequirementFormatter
        categorizedTrainingModules={this.props.trainingModules}
        onTrainingUpdate={ this.props.updateTrainingRequirement }
        value={ cell }
        rowIndex={ rowIndex }
        disabled={this.props.disabledCells}
        trainingModule={training_module}
        traineeTeams={row.tag_list}
      />
    )
  }

  nameCellFormatter = (cell, row, rowIndex) => {
    row.rowIndex = rowIndex
    return (
      <MatrixTraineeDetails
        trainee={row}
        updateTraineeDetails={this.props.updateTraineeDetails}
        disabled={true}
      />
    )
  }

  rowStyles = (row, rowIndex) => {
    if (row.archived) return { pointerEvents: 'none', opacity: '0.5' }
  }

  render() {
    const { trainingMatrix } = this.state
    return (
        <div ref={this.tableRef} className='matrix-table'>
          { 
            trainingMatrix.length !==0 && 
            <BootstrapTable
              keyField="id"
              data={ trainingMatrix }
              columns={ this.columns }
              headerClasses="table-modules-header"
              rowStyle = { this.rowStyles }
              tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }}
              hover
              condensed
            />
          }
          { (trainingMatrix.length ===0 && !this.props.dataLoading) &&
            <div className="no-data-indication">
              <i className="file alternate icon"></i>
              No Training records. Press 'Add Trainee' button to create a training record.
            </div>
          }
          { 
            (trainingMatrix.length ===0 && this.props.dataLoading) &&
            <div className="loading-message">
              <i className="loading circle notched icon"></i>
              <span>Loading matrix...</span>
            </div>
          }

      </div>
    )
  }
}

export default MatrixTable;



// WEBPACK FOOTER //
// ./src/views/components/tables/matrix_table.js